import { render, staticRenderFns } from "./TrueOrFalse.vue?vue&type=template&id=92c5d57a&"
import script from "./TrueOrFalse.vue?vue&type=script&lang=js&"
export * from "./TrueOrFalse.vue?vue&type=script&lang=js&"
import style0 from "./TrueOrFalse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrueOrFalse.vue"
export default component.exports